import { Link as RouterLink } from 'react-router-dom'
import { Alert, Button, type SxProps } from '@mui/material'
import { DASHBOARD_LINKS } from '@yourownmetric/shared'

import { apiErrorKind } from '@/apis/portalTypes'
import { v2ErrorMessage } from '@/apis/v2Mappers'

/**
 * Error for the portal / scheduled-report admin routes: 402 plan limits link to
 * billing, 403 explains the owner/admin requirement, the rest show the API message.
 */
export function ApiErrorAlert({ error, sx }: { error: unknown; sx?: SxProps }) {
    const kind = apiErrorKind(error)
    if (!kind) {
        return null
    }
    const message = v2ErrorMessage(error)
    if (kind === 'forbidden') {
        return (
            <Alert severity="info" sx={sx}>
                Only organization owners and admins can manage client portals and scheduled reports.
                Ask an admin of this organization for access.
            </Alert>
        )
    }
    if (kind === 'plan_limit') {
        return (
            <Alert
                severity="warning"
                sx={sx}
                action={
                    <Button
                        component={RouterLink}
                        to={DASHBOARD_LINKS.billing}
                        color="inherit"
                        size="small"
                    >
                        View plans
                    </Button>
                }
            >
                {message}
            </Alert>
        )
    }
    if (kind === 'not_configured') {
        return (
            <Alert severity="warning" sx={sx}>
                {message ?? 'Email sending is not configured on this server.'}
            </Alert>
        )
    }
    return (
        <Alert severity="error" sx={sx}>
            {message}
        </Alert>
    )
}
